import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { ModelService } from '../../../../services/model.service';
import { GlobalService } from '../../../../services/global.service';
import { LoginService } from '../../../../services/login.service';
import { Calculation } from '../../../../../classes/Calculations';
import { Images } from '../../../../../classes/Images';
import { COLORS } from '../../../../data/colors';

import * as $ from 'jquery';


@Component({
  selector: 'project-proposal-tab',
  templateUrl: './proposal-tab.component.html',
  styleUrls: ['./proposal-tab.component.scss']
})
export class ProposalTabComponent implements OnInit {

  // Heights calculation for graphs
  graphHeights: any = {
    A: [
      [0, 0],
      [0, 0]
    ],
    B: [
      [0, 0],
      [0, 0]
    ],
    C: [
      [0, 0],
      [0, 0]
    ]
  };

  activeTab: string = 'detail';
  saveRateButtonDisabled: boolean = true;
  hasJobDetails: boolean = false;

  proposalMailInfo: any = {
    type:         'proposal',
    project_id:   0,
    mailFrom:     '',
    mailTo:       '',
    cc:           '',
    subject:      '',
    message:      '',
    is_mailed:    false,
    is_generated: true
  };

  _totalSellPrice: any = {
    A: 0,
    B: 0,
    C: 0
  };

  _totalSellPriceNF: any = {
    A: '0.00',
    B: '0.00',
    C: '0.00'
  };

  _totalProfitNF: any = {
    A: '0.00',
    B: '0.00',
    C: '0.00'
  };

  options_array = ['A','B','C'];


  options_names = {
    'A': 'Option A',
    'B': 'Option B',
    'C': 'Option C'
  };

  _colorsList = COLORS;

  imagePlaceholderBase64: string = Images.projectZonesImagePlaceholder;

  @Input( )	proposalEmail: any = {};
  @Input( ) permission: any = '';
  @Input( )	projectInfo: any = {};
  @Input( )	options: any = {};
  @Input( )	calculation: Calculation = new Calculation( );
  @Input( )	rebatesInfo: any[] = [];
  @Input( )	bindedColors: any[] = [];
  @Input( )	showInProposal: any[] = [];
  /*@Input( )	showSavings: any[] = [];*/
  @Input( 'projectID' )	id: number;

  @Output( 'generatePDFHandler' ) generatePDFHandler: EventEmitter<any> = new EventEmitter( );
  @Output( 'successCallback' ) successCallback: EventEmitter<any> = new EventEmitter( );

  _productsForOverride: Array<any> = [];

  constructor ( 
    public global: GlobalService,
    private model: ModelService,
    public loginService: LoginService
    ) { }

  ngOnInit ( ) {
    this.proposalMailInfo.project_id = this.id;
  }

  ngOnChanges ( changes: SimpleChanges ) { 

    this.hasJobDetails = this.projectInfo.jobDetails && this.projectInfo.jobDetails
                            .replace(/<div[^>]*?>/gi, "").replace(/<\/div>/gi, "")
                            .replace(/<br(\s)*(\/)?>/gi,"").trim() != '';

    if ( changes['calculation'] ) {
      this.calculateHeights( );

      this._productsForOverride = [];
      this._totalSellPrice = {
                              A: 0,
                              B: 0,
                              C: 0 };
      this.calculation.all_options.forEach( prod => {
        this._totalSellPrice[prod.option] += (+prod.sellPrice.replace(/\,/gi, '.')) * (+prod.quantity.replace(/\,/gi, ''));
        this._totalSellPriceNF[prod.option] = this.addCommas(this._totalSellPrice[prod.option].toFixed(2));
        this._totalProfitNF[prod.option] = this.addCommas((this._totalSellPrice[prod.option] - this.calculation[prod.option].total_buy_price).toFixed(2));
        this._productsForOverride.push( Object.assign({}, prod) );
      });

      this.saveRateButtonDisabled = true;
    }

    if ( changes['proposalEmail'] ) {
      this.proposalMailInfo.mailFrom       = this.proposalEmail.mailFrom;
      this.proposalMailInfo.mailTo         = this.proposalEmail.mailTo;
      this.proposalMailInfo.cc             = this.proposalEmail.cc;
      this.proposalMailInfo.subject        = this.proposalEmail.subject;
      this.proposalMailInfo.message        = this.proposalEmail.message;
      this.proposalMailInfo.is_mailed      = this.proposalEmail.is_mailed;
      this.proposalMailInfo.is_generated   = this.proposalEmail.is_generated;
    }
  }

  calculateHeights() {

    let options = ['A','B','C'];

    let calculation = this.calculation;
    let graphHeights = this.graphHeights;
    options.forEach( function( option ) {

      // First graph
      if ( calculation[option].existing_kWhs_number && calculation[option].proposed_kWhs_number ) {
        let _existing1 = +( calculation[option].existing_kWhs_number );
        let _proposed1 = +( calculation[option].proposed_kWhs_number );
        graphHeights[option][0][0] = 250 * _existing1 / ( _existing1 + _proposed1 );
        graphHeights[option][0][1] = 250 * _proposed1 / ( _existing1 + _proposed1 );
      }
      // Second graph
      if ( calculation[option].lifetime_kWh_existing_number && calculation[option].lifetime_kWh_proposed_number ) {
        let _existing2 = +( calculation[option].lifetime_kWh_existing_number );
        let _proposed2 = +( calculation[option].lifetime_kWh_proposed_number );
        graphHeights[option][1][0] = 250 * _existing2 / ( _existing2 + _proposed2 );
        graphHeights[option][1][1] = 250 * _proposed2 / ( _existing2 + _proposed2 );
      }
    });
    this.graphHeights = graphHeights;
  }

  sendProposalMail ( ) {

    let _message;
    _message = $.trim( $( '#textareaProposalEmailMessage' ).text( ) );

    if ( _message == "" ) {
      this.global.defaultErrorCallback( 'Field "Message to client" cannot be empty!', false );
      return false;
    }

    this.proposalMailInfo.message = $( '#textareaProposalEmailMessage' ).html( );


    let data = { message: 'Is information in "To", "Subject" and "Your message to client" fields correct and up to date?' };


    if (this.proposalMailInfo.is_mailed) {
      data.message = 'Proposal for this Project was already emailed. Do you want to email it again?';
    }

    this.global.confirmMessage( data, ( ) => {
      this.model.sendDataEmail( this.proposalMailInfo, ( response ) => {

        this.successCallback.emit( 'Proposal was emailed successfully!' );
        this.proposalMailInfo.mailFrom = response.data.mailFrom;
        this.proposalMailInfo.mailTo = response.data.mailTo;
        this.proposalMailInfo.cc = response.data.cc;
        this.proposalMailInfo.subject = response.data.subject;
        this.proposalMailInfo.message = response.data.message;
        this.proposalMailInfo.is_mailed = response.data.is_mailed;
        this.proposalMailInfo.is_generated = response.data.is_generated;
      });
    });
  }

  changeProposalInnerTab ( tabname: string ) { this.activeTab = tabname; }

  generateProposalPDF ( ) {

    if ( this.projectInfo.hasInactiveProducts ) {
      this.global.defaultErrorCallback( 'There are Inactive products in this Project, which need to be either replaced or removed', false );
    } else {

      let data = {
        message: 'Did you verify that all line item prices are correct on Product Price Override tab?',
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel"
      };

      this.global.confirmMessage( data, ( ) => {
        let html = [
          $( '#proposal-info-A' ).html( ),
          $( '#proposal-info-B' ).html( ),
          $( '#proposal-info-C' ).html( ),
          $( '#jobDetails' ).html( )
        ];
        this.model.getProposalPDF( this.calculation, html, this.id, this.projectInfo, ( url, responseData ) => {
          this.global.openLinkNewTab( url );

          this.proposalMailInfo.mailFrom 		= responseData.mailFrom;
          this.proposalMailInfo.mailTo 			= responseData.mailTo;
          this.proposalMailInfo.cc 				= responseData.cc;
          this.proposalMailInfo.subject 		= responseData.subject;
          this.proposalMailInfo.message 		= responseData.message;
          this.proposalMailInfo.is_mailed 		= responseData.is_mailed;
          this.proposalMailInfo.is_generated 	= responseData.is_generated;

          this.generatePDFHandler.emit( );
        });
      });
    }
  }

  trackByIndex ( index: number, obj: any ): any {
    return index;
  }

  recalculateSellPrice ( product ) {
    if ( product.buyPrice ) {
      if ( product.markup ) {
        product.sellPrice = ( +product.buyPrice + ( (+product.buyPrice) * (+product.markup) / 100 ) ).toFixed( 2 ).toString( );
      } else {
        product.sellPrice = +product.buyPrice;
      }
    }
  }

  recalculateMarkup ( product ) {
    if ( product.sellPrice ) {
      if ( product.buyPrice ) {
         product.markup = ( 100 * ( ( (+product.sellPrice) - (+product.buyPrice) ) / (+product.buyPrice) ) ).toFixed( 1 ).toString( );
      }
    }
  }

  changeProductRate ( product, type ) {

    if ('markup' === type) {
      this.recalculateSellPrice(product);
    }

    if ('sellPrice' === type) {
      this.recalculateMarkup(product);
    }

    let _hasNegative = false;

    this.saveRateButtonDisabled = true;
    this._totalSellPrice = {
      A: 0,
      B: 0,
      C: 0 };
    this._productsForOverride.forEach((changedProduct)=>{
      this._totalSellPrice[changedProduct.option] += (+changedProduct.sellPrice) * (+changedProduct.quantity.replace(/\,/gi, ''));
      this._totalSellPriceNF[changedProduct.option] = this.addCommas(this._totalSellPrice[changedProduct.option].toFixed(2));
      this._totalProfitNF[changedProduct.option] = this.addCommas((this._totalSellPrice[changedProduct.option] - this.calculation[changedProduct.option].total_buy_price).toFixed(2));
      this.calculation.all_options.forEach((defaultProduct)=>{
        if (changedProduct.id === defaultProduct.id) {
          if (changedProduct.markup < 0 || changedProduct.sellPrice < 0) {
            _hasNegative = true;
          }
          if (changedProduct.markup !== defaultProduct.markup || changedProduct.sellPrice !== defaultProduct.sellPrice) {
            this.saveRateButtonDisabled = false;
          }
          if (_hasNegative) {
            this.saveRateButtonDisabled = true;
          }
        }
      });
    });

    this._totalSellPrice.A = this._totalSellPrice.A.toFixed(2);
    this._totalSellPrice.B = this._totalSellPrice.B.toFixed(2);
    this._totalSellPrice.C = this._totalSellPrice.C.toFixed(2);

  }

  saveLightPrices ( ) {

    let _answer;

    this.model.saveLightPrices( this.id, this._productsForOverride, ( response ) => {
      _answer = response.answer;
      this.saveRateButtonDisabled = true;
      if ( _answer == 'success' ) this.successCallback.emit( 'New product(s) rate(s) has been saved successfully!' );
      else this.global.defaultErrorCallback( _answer, false );

    });

  }

  addCommas(nStr) {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/projects/project/proposal-tab/proposal-tab.component.ts